import React, { useEffect, useState } from 'react'
import { Modal, Row, Table, Input, Col, Timeline, Radio, message, Form, Upload } from 'antd'
import { ColumnsType, TablePaginationConfig } from 'antd/es/table'
import { useHomerModal } from './homeModel'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from '@/utils/constants'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import { FC } from 'react'
import { ModeType } from '@/model/navModel'
import TextArea from 'antd/lib/input/TextArea'
import { formatNum, momentFormat } from '@/utils/utils'
import { globalPrompt } from '@/components/message'
import FontIcon from '@/components/YhIcon'
import { UploadChangeParam, UploadFile } from 'antd/lib/upload/interface'
import { fileDownload } from '@/utils/exportFile'
import { FileImageTwoTone } from '@ant-design/icons'
import { ISCMApplyListDetail } from '../apply/applyList/applyListTypes'
import { applyListService } from '../apply/applyList/applyListService'
import { Image } from 'antd';
import YhTootip from '@/components/YhTootip'

export const ApplyModal = () => {
    const { user: { userName },fetchUserList,userData} = useGlobalModel();
    const { applyVisible: visible, setApplyVisible,loadData,applyDetailList, editFormVal,getOneData, applyHistoryList,  setApplyHistoryList,nextApplyUser } = useHomerModal()
    const [applyData, setApplyData] = useState<any>({})
 

    const columns: ColumnsType<ISCMApplyListDetail> = [
        {
            title: '审批人',
            width: 100,
            dataIndex: 'user',
        }, {
            title: '审批时间',
            width: 120,
            dataIndex: 'processTime',
            render: (text) => `${momentFormat(text)}`
        }, {
            title: '审批结果',
            width: 100,
            dataIndex: 'supplierName',
            render: (text: string,record:any) => <span>{record.isApprove==1?'已通过':record.isApprove==2?'已驳回':'待审批'}</span>

        }, {
            title: '审批备注',
            width: 160,
            dataIndex: 'note',
        }, 
    ];
    const abandonColumns: ColumnsType<ISCMApplyListDetail> = [
        {
            title: '序号',
            width: 50,
            fixed: "left",
            align: "center",
            render: (t: any, r: any, i: number) => i + 1
        },
        // {
        //     title: '物资图片',
        //     width: 120,
        //     align: "center",
        //     fixed: "left",
        //     render: (text, records) => (records.md5 ? <Image src={getBaseImgLookUrl(records.md5)}  style={{maxWidth:'50px',maxHeight:'70px'}}/> : null)
        // },  
        {
            title: '物资编码',
            width: 140,
            dataIndex: 'materialCode',
            fixed: "left",
        }, {
            title: '物资名称',
            width: 160,
            dataIndex: 'materialName',
            fixed: "left",
        }, {
            title: '物资类型',
            width: 100,
            dataIndex: 'typeName',
        },
        // {
        //     title: '规格型号',
        //     width: 130,
        //     dataIndex: 'model',
        // },  {
        //     title: '单位',
        //     width: 80,
        //     dataIndex: 'unitName',        },  {
        //     title: '单价',
        //     width: 90,
        //     dataIndex: 'price',
        //     render: (text: any) => `￥${formatNum(text)}`
        // }, {
        //     title: '报废数量',
        //     width: 100,
        //     dataIndex: 'num',
        // }, {
        //     title: '合计',
        //     width: 100,
        //     dataIndex: 'amount',
        //     render: (text: any) => `￥${formatNum(text ?? 0)}`
        // }, 
        // {
        //     title: '当前存放地点',
        //     width: 130,
        //     dataIndex: 'deposit',
        // }, 
        // {
        //     title: '条形码',
        //     width: 100,
        //     dataIndex: 'barCode',
        // },{
        //     title: '备注',
        //     width: 140,
        //     dataIndex: 'note',
        // } ,
        {
            title: '仓库',
            width: 130,
            dataIndex: 'warehouseName',
            // fixed: "right",
        },
        {
            title: '货位',
            width: 130,
            dataIndex: 'shelfCode',
            // fixed: "right",
        }, 
        // {
        //     title: '当前使用人',
        //     width: 120,
        //     dataIndex: 'user',
        //     // fixed: "right",
        // }
    ];
        const moveColumns: ColumnsType<ISCMApplyListDetail> = [
            {
                title: '序号',
                width: 50,
                fixed: "left",
                align: "center",
                render: (t: any, r: any, i: number) => i + 1
            },
            // {
            //     title: '物资图片',
            //     width: 120,
            //     align: "center",
            //     fixed: "left",
            //     render: (text, records) => (records.md5 ? <Image src={getBaseImgLookUrl(records.md5)}  style={{maxWidth:'50px',maxHeight:'70px'}}/> : null)
            // },
             {
                title: '物资编码',
                width: 140,
                dataIndex: 'materialCode',
                fixed: "left",
            }, {
                title: '物资名称',
                width: 160,
                dataIndex: 'materialName',
                fixed: "left",
            }, {
                title: '物资类型',
                width: 100,
                dataIndex: 'typeName',
             }, 
            // {
            //     title: '规格型号',
            //     width: 130,
            //     dataIndex: 'model',
            //     render: (text: string) =><YhTootip text={text} />,      
            // },  {
            //     title: '单位',
            //     width: 80,
            //     dataIndex: 'unitName',
            // },  {
            //     title: '单价',
            //     width: 90,
            //     dataIndex: 'price',
            //     render: (text: any) => `￥${formatNum(text)}`
            // }, {
            //     title: '转移数量',
            //     width: 100,
            //     dataIndex: 'num',
            // }, {
            //     title: '合计',
            //     width: 100,
            //     dataIndex: 'amount',
            //     render: (text: any) => `￥${formatNum(text ?? 0)}`
            // }, 
            // {
            //     title: '原存放地点',
            //     width: 130,
            //     dataIndex: 'beforeDeposit',
            // },
            // {
            //     title: '原使用人',
            //     width: 120,
            //     dataIndex: 'beforeUser',
            // },
            // {
            //     title: '转入地点',
            //     width: 130,
            //     dataIndex: 'deposit',
            // },
            // {
            //     title: '备注',
            //     width: 140,
            //     dataIndex: 'note',
            // },
            {
                title: '仓库',
                width: 130,
                dataIndex: 'warehouseName',
                // fixed: "right",
            },
            {
                title: '货位',
                width: 170,
                dataIndex: 'shelfCode',
                // fixed: "right",
            }, 
            {
                title: '现使用人',
                width: 120,
                dataIndex: 'user',
                // fixed: "right",
            },
    
        ];

    const onClose = () => {
        setApplyVisible(false)
    }
    const onOk = async () => {
        let applyId=getOneData[nextApplyUser].find((list)=>list.user==userName).id
        try {
            if(!applyData.isApprove){
                message.warning('请选择审批结果！')
                return
            }
            if(applyData.isApprove==2&&!applyData.note){
                message.warning('请输入驳回原因！')
                return
            }
			let { retData } = await applyListService.audit({...applyData,id:applyId});
			globalPrompt("message", { text: "审批成功！", type: "success" })
            setApplyVisible(false)
            loadData()
		} catch (error) {
            globalPrompt("message", { text: "审批失败！", type: "warning" })
			setApplyVisible(false)
            loadData()
		}
    }
    const onPreview = (file: UploadFile<any>) => {
        const { uid, name } = file
        const type = uid.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: '图片查看',
                content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(uid)} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        } else {
            fileDownload(getBaseImgLookUrl(uid), name)
        }
    }
    return (
        <Modal
            visible={visible}
            title="审批"
            onCancel={onClose}
            onOk={onOk}
            width={1080}
        >
            <Row justify="end" style={{ marginBottom: '26px' }}>
                <Col span={2}>
                    <span style={{ lineHeight: '40px' }}>{editFormVal.typeCode=='assets-apply-type.purchase'?'采购申请：':
                    editFormVal.typeCode=='assets-apply-type.transfer'?'转移申请：':'报废申请：'
                    }</span>
                </Col>
                <Col span={22}>
                {editFormVal.typeCode=='assets-apply-type.purchase'&&<TextArea autoSize={{ minRows: 4, maxRows: 6 }} value={editFormVal.note} />}
                {editFormVal.typeCode=='assets-apply-type.discard'&&<Table rowKey={(record) => record.id} columns={abandonColumns} dataSource={applyDetailList} bordered scroll={{ x: '900',y:'200' }}pagination={false}/>}
                {editFormVal.typeCode=='assets-apply-type.transfer'&&<Table rowKey={(record) => record.id} columns={moveColumns} dataSource={applyDetailList} bordered scroll={{ x: '900',y:'200' }}pagination={false}/>}
                </Col>
            </Row>
            <Row style={{ marginBottom: '26px' }}>
                <Col span={6}>
                <span style={{ lineHeight: '30px' }}>申请部门： {editFormVal.departmentName}</span>
                </Col>
                <Col span={6}>
                    <span style={{ lineHeight: '30px' }}>申请时间： {editFormVal.createTime ? momentFormat(editFormVal.createTime) : ''}</span>
                </Col>
                <Col span={6}>
                    <span style={{ lineHeight: '30px' }}>申请人： {editFormVal.createUser}</span>
                </Col>
                {editFormVal.typeCode=='assets-apply-type.transfer'&&<Col span={6}>
                    <span style={{ lineHeight: '30px' }}>转出部门： {editFormVal.departmentOutName}</span>
                    {/* <span style={{ lineHeight: '30px' }}>转出部门： {editFormVal.departmentName}</span> */}
                </Col>}
            </Row>
            <Row style={{ marginBottom: '26px' }}>
                <Col span={2}>
                    <span style={{ lineHeight: '30px' }}>申请附件：</span>
                </Col>
                <Col span={20}>
                {editFormVal.fileList.map((list)=>{
                    return (<div  onClick={() =>onPreview(list)} style={{cursor:'pointer'}}>
                        <FileImageTwoTone />
                        <span style={{marginLeft:'5px'}}>{list.name}</span>
                    </div>
                    )
                })}
                </Col>
            </Row>
            <Row style={{ marginBottom: '26px' }}>
                <Col span={2}>
                    <span style={{ lineHeight: '40px' }}>审批记录：</span>
                </Col>
                <Col span={22}>
                    <Table rowKey={(record) => record.id} columns={columns} dataSource={applyHistoryList} bordered />
                </Col>
            </Row>
            <Row style={{ marginBottom: '26px' }}>
                <Col span={2}>
                    <span style={{ lineHeight: '40px' }}>审批人：</span>
                </Col>
                <Col span={22}>
                <Timeline>
                        <Timeline.Item color="green" style={{ marginLeft: '5px' }}>
                            <span style={{ marginRight: '40px', fontSize: '17px', marginBottom: '15px', fontWeight: 'bold' }}></span>
                            {/* {nextApplyUser} */}
                            {getOneData[nextApplyUser] &&
                                getOneData[nextApplyUser].map((item: any,index) => {
                                    return (
                                        // <Row>
                                        <>
                                            {index!==0&&<span style={{color: '#70707a'}}>——————</span>}
                                            <span style={{marginLeft: '20px',fontSize: '16px',color: '#70707a'}}>{item.departmentName}</span>
                                            <span style={{marginLeft: '8px',marginRight: '60px',fontSize: '15px',color: 'blue'}}>{item.isApprove?'(审批)':'(未审批)'}</span>
                                            <span style={{marginLeft: '20px',marginRight: '60px',fontSize: '16px',color: '#70707a'}}>{item.user}</span>
                                        </>
                                        // </Row>
                                    )
                                })}
                        </Timeline.Item>
                    </Timeline>
                </Col>
            </Row>
            <Row style={{ marginBottom: '26px' }}>
                <Col span={2}>
                    <span style={{ lineHeight: '30px' }}>审批结果：</span>
                </Col>
                <Col span={22}>
                <Radio.Group value={applyData.isApprove} onChange={(e) =>setApplyData({...applyData, isApprove: e.target.value })}>
                        <Radio.Button value={1}>通过</Radio.Button>
                        <Radio.Button value={2}>驳回</Radio.Button>
                    </Radio.Group>
                </Col>
            </Row>
            <Row style={{ marginBottom: '26px' }}>
                <Col span={2}>
                    <span style={{ lineHeight: '40px' }}>审批备注：</span>
                </Col>
                <Col span={22}>
                   <TextArea 
                   autoSize={{ minRows: 4, maxRows: 6 }} 
                   value={applyData.note}                             
                   onChange={(e) => {
                    setApplyData({...applyData, note: e.target.value })
                            }}/>
                </Col>
            </Row>
        </Modal>
    )
}
